module.exports = __webpack_public_path__ + "img/clearscore.5ce94417.svg";